module.exports = __webpack_public_path__ + "img/nav3.b670be65.png";